import { useState, useEffect } from 'react';
import { config } from '../config';

const API_STATIC_ORIGIN = (config.api.web || '').replace(/\/?api\/?$/i, '');

export function withAvatarCacheBust(url) {
  const v = String(url || '').trim();
  if (!v) {
    return '';
  }
  const sep = v.includes('?') ? '&' : '?';
  return `${v}${sep}v=${Date.now()}`;
}

export function resolveAvatarUrl(value) {
  const v = String(value || '').trim();
  if (!v) {
    return '';
  }
  if (/^https?:\/\//i.test(v)) {
    return v;
  }
  if (v.startsWith('/')) {
    return `${API_STATIC_ORIGIN}${v}`;
  }
  if (v.startsWith('avatar/')) {
    const base = (config.s3?.baseUrl || '').replace(/\/?$/, '/');
    return base ? `${base}${v}` : v;
  }
  if (/^user_[^/]+\.webp$/i.test(v)) {
    const base = (config.s3?.baseUrl || '').replace(/\/?$/, '/');
    return base ? `${base}avatar/${v}` : v;
  }
  return v;
}

export function initialsFromName(name, lastN, emailFallback) {
  const n = String(name || '').trim();
  const l = String(lastN || '').trim();
  const first = (s) => (s?.charAt(0) || '').toUpperCase();
  if (n && l) {
    return `${first(n)}${first(l)}`;
  }
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${first(parts[0])}${first(parts[parts.length - 1])}`;
  }
  if (n.length >= 2) {
    return n.slice(0, 2).toUpperCase();
  }
  if (n) {
    return first(n);
  }
  const em = String(emailFallback || '').trim();
  if (em) {
    return em.slice(0, 2).toUpperCase();
  }
  return '?';
}

export function AvatarOrInitials({
  avatarUrl = '',
  name = '',
  lastN = '',
  emailFallback = '',
  className = '',
  alt = '',
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const src = imgFailed ? '' : resolveAvatarUrl(avatarUrl);
  const initials = initialsFromName(name, lastN, emailFallback);
  const label = alt || `Avatar de ${[name, lastN].filter(Boolean).join(' ').trim() || 'usuario'}`;

  useEffect(() => {
    setImgFailed(false);
  }, [avatarUrl]);

  if (!src) {
    return (
      <span className={`avatar-initials ${className}`.trim()} role="img" aria-label={label}>
        {initials}
      </span>
    );
  }

  return (
    <img
      key={src}
      className={className}
      src={src}
      alt={label}
      onError={() => setImgFailed(true)}
    />
  );
}
